import { Serializers, SerializerValue } from "@megaron/serializers";

export const budgetFiltersSerializer = Serializers.object({
  page: Serializers.integer,
  searchText: Serializers.string,
  isArchived: Serializers.booleanFieldFilter,
}).partial();

export type BudgetFilters = SerializerValue<typeof budgetFiltersSerializer>;
